module.exports = __webpack_public_path__ + "m2.png";